import React, { useState, useEffect } from "react";
import { useOktaAuth } from "@okta/okta-react";

import { useDispatch, useSelector } from "react-redux";

import * as userActions from "redux/actions/userActions";
import * as clientActions from "redux/actions/clientActions";

import Logo from "./Logo";
import NavLinks from "./NavLinks";
import RightPanel from "./RightPanel";

import { Container } from "./styles";
import { withRouter, useLocation } from "react-router";
import { useHistory } from "react-router-dom";
import {
  TransactionNotificationComment,
  LeaseEventNotificationComment,
  PreTransactionNotificationComment,
  LeaseEvent,
  Transaction,
} from "../../shared/utils/constants";
import NotificationAlert from "components/Notification/NotificationAlert";

const Header = () => {
  const dispatch = useDispatch();
  const { authState } = useOktaAuth();
  const [loading, setLoading] = useState(false);

  const { selectedClient } = useSelector((state) => state.clients);
  const selectedClientId = selectedClient?.clientId;

  const user = useSelector((state) => state.currentUser.details);

  const { userEmailAddress, isAdmin } = user || {
    userEmailAddress: "",
    userName: "",
    isAdmin: false,
  };

  const { setSelectedClient } = clientActions;
  const { getUserClients, trackUserActivity } = userActions;

  const history = useHistory();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const notificationId = queryParams.get('id');
  const notificationType = queryParams.get('type');
  const alertTitle = notificationType && notificationType === "tr" ? "Some transactions may not be visible" : 
  notificationType && notificationType === "le" ? "Some lease events may not be visible":
  "Comment is no longer available";
  const alertMessage = notificationType && notificationType === "tr" ?"Transactions due dates have been changed or it's been over 30 days since you were notified." 
  : notificationType && notificationType === "le" ? "Lease events notice dates have been changed or it's been over 30 days since you were notified."
  : "The comment has been deleted, or you have been removed from the comment.";

    const [notificationAlert, setNotificationAlert] = useState({
      message: "",
      severity: "success",
      title: "",
      open: false,
    });

  const buildRequest = () => {
    let request = {
      clientId: selectedClientId,
      createdBy: userEmailAddress,
      pageURL: location.pathname === "/" ? "/Home" : location.pathname,
      userEmail: userEmailAddress,
    };

    return request;
  };

  useEffect(() => {
    if (!user || !userEmailAddress) return;

    const request = buildRequest();

    dispatch(trackUserActivity(request));
  }, [user, location, selectedClientId]);

  useEffect(() => {
    if (!user) return;
    if (
      user.hasOwnProperty("isAdmin") &&
      location.pathname.startsWith("/admin") &&
      !user.isAdmin
    ) {
      history.push("/unauthorized");
    }

    if (userEmailAddress) {
      setLoading(true);

      dispatch(getUserClients(userEmailAddress))
        .then((res) => {
          // console.log("userClients", res.payload?.data);

          if (res.payload.data.length === 0) {
            history.push("/unauthorized");
          } else {
            let clientToSet, patClientId;
            if (notificationId) {
              validateAndRedirect(notificationId, res.payload.data);
            }
            else if (
              location.search &&
              Number.isInteger(+location.search.split("=")[1])
            ) {
              //check if URL has PATClientId and isInteger
              patClientId = location.search.split("=")[1];
              clientToSet = res.payload.data.find(
                (r) => r.patClientId === patClientId
              );
            }

            if (patClientId || !selectedClientId) {
              if (isAdmin) {
                clientToSet = !clientToSet //failsafe in case client is null.
                  ? res.payload.data.filter((r) =>
                      r.clientName.startsWith("Demo Client")
                    )[0]
                  : clientToSet;
              } else {
                clientToSet = !clientToSet //failsafe in case client is null.
                  ? res.payload.data[0]
                  : clientToSet;
              }
            }

            if (clientToSet) {
              dispatch(setSelectedClient(clientToSet));
              localStorage.setItem(
                "selectedClient",
                JSON.stringify(clientToSet)
              );
            }
          }
        })
        .catch((error) => {
          console.log(error.message);
        })
        .finally(() => setLoading(false));
    }
  }, [user]);

  const validateAndRedirect = (notificationId, userclients) => {
    dispatch(userActions.getNotificationById(notificationId)).then((res) => {
      var notification = res.payload.data;
      let currentClient;
      if (notification) {
        var isValidUser = userclients.some(
          (x) => x.clientId === notification.clientId
        );
        if (isValidUser) {
          currentClient = userclients.filter(
            (x) => x.clientId === notification.clientId
          );
          if (currentClient && currentClient.length > 0) {
            dispatch(setSelectedClient(currentClient[0]));
            localStorage.setItem(
              "selectedClient",
              JSON.stringify(currentClient[0])
            );
            dispatch(userActions.setSelectedNotificationComment(notification));
            if (notification.type === TransactionNotificationComment) {
              history.push(
                `/transaction/comments/${notification.typeEntityId}`
              );
            } else if (
              notification.type === PreTransactionNotificationComment
            ) {
              history.push(
                `/pre-transaction/comments/${notification.typeEntityId}`
              );
            } else if (
              notification.type === LeaseEventNotificationComment ||
              notification.type === LeaseEvent
            ) {
              history.push(`/lease-event`);
            } else if (notification.type === Transaction) {
              history.push(`/transaction`);
            }
          }
        } else {
          currentClient = userclients.some((x) =>
            x.clientName.startsWith("Demo Client")
          )
            ? userclients.filter((r) =>
                r.clientName.startsWith("Demo Client")
              )[0]
            : userclients[0];
          dispatch(setSelectedClient(currentClient));
          localStorage.setItem("selectedClient", JSON.stringify(currentClient));
          setNotificationAlert({
            message:alertMessage,
            severity: "error",
            title: alertTitle,
            open: true,
          });
          history.push("/");
        }
      } else {
        currentClient = userclients.some((x) =>
          x.clientName.startsWith("Demo Client")
        )
          ? userclients.filter((r) => r.clientName.startsWith("Demo Client"))[0]
          : userclients[0];
        dispatch(setSelectedClient(currentClient));
        localStorage.setItem("selectedClient", JSON.stringify(currentClient));
        setNotificationAlert({
          message: alertMessage,
          severity: "error",
          title: alertTitle,
          open: true,
        });
        history.push("/");
      }
    });
  };

  const onAlertClose = () => {
      setNotificationAlert({
        message: "",
        severity: "",
        title: "",
        open: false,
      });
    };

  return (
    <Container>
      <NotificationAlert
        onClose={onAlertClose}
        message={notificationAlert.message}
        open={notificationAlert.open}
        title={notificationAlert.title}
        severity={notificationAlert.severity}
      ></NotificationAlert>
      <Logo />
      <NavLinks selectedClient={selectedClient} />
      <div style={{ flex: 1 }} />
      <RightPanel loading={loading} />
    </Container>
  );
};

export default withRouter(Header);
